export interface Preferences {
  loginName: string;
  languageCode: string;
  languageName: string;
  showNumberOfRows: number;
  lastLogin: string;
}
